import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { lumi } from '@/lib/lumi'
import type { SiteSetting } from '@/types'
import { initGoogleAnalytics, isValidGaId, trackGaPageView } from '@/lib/googleAnalytics'

export default function GoogleAnalytics() {
  const location = useLocation()
  const [measurementId, setMeasurementId] = useState('')
  const lastPath = useRef('')

  useEffect(() => {
    let cancelled = false
    lumi.entities.site_settings.list({
      filter: { key: 'ga_measurement_id' },
      limit: 1,
    }).then((res) => {
      if (cancelled) return
      const value = ((res?.list?.[0] as SiteSetting | undefined)?.value || '').trim()
      if (!isValidGaId(value)) return
      initGoogleAnalytics(value)
      setMeasurementId(value)
    }).catch((error) => {
      console.error('Erro ao carregar Google Analytics:', error)
    })
    return () => { cancelled = true }
  }, [])

  useEffect(() => {
    if (!measurementId) return
    const path = `${location.pathname}${location.search}`
    if (path.startsWith('/admin')) return
    if (lastPath.current === path) return
    lastPath.current = path
    trackGaPageView(measurementId, path)
  }, [location.pathname, location.search, measurementId])

  return null
}
